<template>
  <b-dropdown class="menu-toggle-wrapper">
    <template slot="button-content">
      <slot></slot>
    </template>
    <b-dropdown-item href="#" @click.prevent="handleDeconnexion"
      >Deconnexion</b-dropdown-item
    >
  </b-dropdown>
</template>
<script>
export default {
  methods: {
    handleDeconnexion () {
      this.$emit('onDeconnexion')
    }
  }
}
</script>

<style lang="scss">
.menu-toggle-wrapper {
  .btn {
    background: transparent !important;
    border: none;
    outline: none;
    &:after {
      display: none;
    }
  }
  .dropdown-menu {
    border: none;
    box-shadow: 0 9px 15px 0 rgba(0, 0, 0, 0.1);
    margin-top: 10px;
    &:before {
      content: "";
      width: 0;
      height: 0;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 7px solid #fff;
      position: absolute;
      top: -7px;
      left: 25px;
    }
    a.dropdown-item {
      color: #2b3085;
      font-size: 12px;
      line-height: 33px;
      font-family: "Open Sans";
      height: 33px;
      padding-top: 0;
      padding-bottom: 0;
      &:hover {
        background-color: #f2f7fa;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userMenuComponent/userToggleMenu.vue